import {DatePicker as RioDatePicker} from "@rio-cloud/rio-uikit";
import {RIODateTime} from "../../lib/RIODateTime.ts";

export enum DatePickerType {
    DATE = "DATE"
}

type DatePickerProps = {
    type: DatePickerType;
    placeholder?: string;
    onChange: (value: RIODateTime) => void;
    value: Date |  undefined;
}

function typeToDateFormat(type: DatePickerType) {
    switch (type) {
        case DatePickerType.DATE:
            return "YYYY-MM-DD";
    }
}

function momentToRioDateTime(momentObject: any) {
    if (!momentObject._isAMomentObject) {
        throw new Error(`${momentObject} is not a moment object`)
    }
    return RIODateTime.FromISO(momentObject.utc(true).toISOString());
}

export const DatePicker = ({type, placeholder, onChange,value}: DatePickerProps) => {
    return <RioDatePicker
        inputProps={{placeholder: placeholder || "Please Select"}}
        dateFormat={typeToDateFormat(type)}
        timeFormat={false}
        value={value}
        onChange={result => onChange(momentToRioDateTime(result))}
    />
}